// extracted by mini-css-extract-plugin
export var columnList = "_de-0";